import React from 'react';

import { CompanyTagsContextType } from './types';

export const CompanyTagsContext = React.createContext<CompanyTagsContextType>({} as CompanyTagsContextType);
